<script>
import Lightpick from 'lightpick'
import { format } from 'date-fns'

export default {
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    options: { type: Object, default: () => ({}) },
    modelValue: { type: [Date, String], default: '' },
    rules: { type: String, default: '' },
  },
  data() {
    return {
      localValue: null,
    }
  },
  computed: {
    localModel: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('change', val)
      },
    },
  },
  mounted() {
    if (this.modelValue) {
      this.localValue = format(this.modelValue, 'DD MMM YYYY')
    }

    var vm = this
    var lpOptions = Object.assign(this.options, {
      field: vm.$refs.dateInput,
      format: 'DD MMM YYYY',
      onSelect: vm.onSelect,
    })

    this.picker = new Lightpick(lpOptions)
  },
  destroyed() {
    this.picker.destroy()
  },
  methods: {
    onSelect(date) {
      this.localModel = date.format('YYYY-MM-DD') // moment js format
      this.localValue = date.format('D MMM YYYY')
    },
  },
}
</script>

<template>
  <ValidationProvider v-slot="{ errors }" :rules="rules" tag="div">
    <input v-model="localModel" type="hidden" />
    <input
      ref="dateInput"
      type="text"
      :value="localValue"
      class="input cursor-pointer"
    />
    <p class="text-red-500 text-xs italic mt-2">
      {{ errors[0] }}
    </p>
  </ValidationProvider>
</template>
